import {isNumber} from 'lodash'
import {useMemo} from 'react'

import {findNextSample} from '../common/cementStrength'
import {CementStrengthSample} from '../declarations'

export const useNextSample = (
  samples: CementStrengthSample[],
  currentSampleId?: number
): CementStrengthSample | undefined => {
  return useMemo(
    () => (isNumber(currentSampleId) ? findNextSample(samples, currentSampleId) : undefined),
    [currentSampleId, samples]
  )
}
